export default "__VITE_ASSET__BKTkLbu6__"